import { defineMessage } from "@lingui/macro";

import { FLOW_TYPE } from "base/constants";

import { ACCOUNT_FEATURES } from "./account.featuregate.constant.js";

export const FLOW_SETTINGS_COLUMNS = [
  {
    Id: "FlowName",
    Name: defineMessage`Flow`,
    ReadOnly: true,
    Width: 160,
    hasFeatureGate: false
  },
  {
    Id: "IsDisabled",
    Name: defineMessage`Status`,
    ReadOnly: true,
    Width: 160,
    hasFeatureGate: false
  },
  {
    Id: "Label",
    Name: defineMessage`Who can create a new flow?`,
    ReadOnly: true,
    Width: 280,
    hasFeatureGate: false
  },
  {
    Id: "Approvers",
    Name: defineMessage`Approvers`,
    ReadOnly: true,
    hasFeatureGate: false
  },
  {
    Id: "Download",
    Name: defineMessage`Download permission`,
    ReadOnly: true,
    Width: 180,
    hasFeatureGate: true,
    feature: [ACCOUNT_FEATURES.ADMIN_ALLOW_DOWNLOAD_CUSTOMIZE]
  },
  {
    Id: "Print",
    Name: defineMessage`Print permission`,
    ReadOnly: true,
    Width: 160,
    hasFeatureGate: true,
    feature: [ACCOUNT_FEATURES.ADMIN_ALLOW_PRINT_CUSTOMIZE]
  },
  {
    Id: "EmailApproval",
    Name: defineMessage`Email Actions`,
    ReadOnly: true,
    Width: 160,
    hasFeatureGate: true,
    feature: [ACCOUNT_FEATURES.ADMIN_ALLOW_EMAIL_APPROVAL]
  }
];

export const FLOW_INFO = [
  {
    ApprovalRule: "",
    label: defineMessage`Anyone`,
    IsDisabled: false
  },
  {
    ApprovalRule: "AdminsOnly",
    label: defineMessage`Super Admins`
  },
  {
    ApprovalRule: "Approval",
    label: defineMessage`Anyone, after the approval of`
  }
];

export const FLOW_INFO_RULES = {
  ADMINS_ONLY: "AdminsOnly",
  APPROVAL: "Approval"
};

export const FLOW_NAMES = {
  Project: FLOW_TYPE.PROJECT,
  Process: FLOW_TYPE.PROCESS,
  Case: FLOW_TYPE.CASE,
  Dataset: FLOW_TYPE.DATASET,
  Integration: FLOW_TYPE.INTEGRATION
};

export const FLOW_TYPE_LIST = {
  Process: {
    key: FLOW_TYPE.PROCESS
  },
  Case: { key: FLOW_TYPE.CASE },
  Project: { key: FLOW_TYPE.PROJECT },
  Dataset: { key: FLOW_TYPE.DATASET },
  Integration: { key: FLOW_TYPE.INTEGRATION }
};

export const FLOW_LABEL = {
  AdminsOnly: "Super Admins",
  Approval: "Anyone, after the approval of"
};

export const STRING_FIELDS = ["Text", "Currency", "Select"];

export const APPROVERS = "Approvers";

export const APPROVAL = "Approval";

export const FLOW_SETTING_HEAP_LOCATORS = {
  Process: "flow_enable_disable_process",
  Case: "flow_enable_disable_case",
  Project: "flow_enable_disable_project",
  Dataset: "flow_enable_disable_dataset",
  Integration: "flow_enable_disable_integration"
};
